<template>
  <div id='bulb-info'>
    <v-content style="min-height: 100%" class="white pa-2">
      <v-layout
        id="bulb-status-section"
        wrap
        text-xs-center
        :mb-3="(
          !isProquestBulb
          || !shouldShowRetakeButton
        )"
      >
        <!-- bulb title-->
        <v-flex xs12 my-2>
          <Tooltip
            top
            tag="h1">
            <h1 :class="[!mobileIOS ? 'bulb-info-title' : 'text-truncate']">
              {{bulb.name}}
            </h1>
            <template v-slot:text>{{bulb.name}}</template>
          </Tooltip>
        </v-flex>
        <!--bulb progress -->
        <v-flex center xs12 my-2>
           <v-progress-circular
            :rotate="-90"
            :size="100"
            :width="15"
            :value="progressCircle"
            :color="bulbAttempt.complete ? 'green' : 'grey'">
            <v-icon v-if="bulbAttempt.complete && (bulb.config.hide_learner_score || user.userType !== 'student')" color="green">check</v-icon>
            {{bulbAttempt.complete && !bulb.config.hide_learner_score && user.userType === "student" ? score.percent + "%" : ''}}
          </v-progress-circular>
        </v-flex>
        <!-- bulb status-->
        <v-flex xs12 my-2>
          <h2>{{bulbAttempt.complete ? 'Complete!' : 'In Progress'}}</h2>
          <h3>{{scoreThreshold.scoreThresholdEnabled ? `You did not score the minimum requirement of ${scoreThreshold.bulbScoreThreshold}%. Please try again until ${scoreThreshold.bulbScoreThreshold}% is reached.` : ''}}
          </h3>
          <br>
          <p v-if='bulbAttempt.complete && !bulb.config.score_disabled && score.ungraded'>{{score.ungraded}} of {{interactions.length}} interaction{{interactions.length > 1 ? 's' : ''}} will be graded by your instructor.</p>
          <p v-if="user.userType === 'student'">{{bulbAttempt.complete ? 'Completed' : 'Completing'}} assignment as {{getUserName}}</p>
        </v-flex>
        <v-flex xs12 v-if="(
            showFinishExit
            && !isDocxButtonInProminentPosition
          )" >
          <v-btn id="finish-and-exit" block color="primary" v-if="!isPlaylist && !isListcode" aria-label='Finish and exit' @click="isProquestBulb ? handleProquestFinishExitClick() : finishExitClicked()">
            Finish and Exit
          </v-btn>
        </v-flex>
        <v-flex xs12  v-if="(
          canDownloadDocx
          && isDocxButtonInProminentPosition
        )">
          <v-btn
            @click="downloadDocx"
            :loading="isDownloadingDocx"
            :disabled="isDownloadingDocx"
            block
            color="primary"
            aria-label="Download grades in a DOCX file."
          >
            Download My Results (DOCX)
          </v-btn>
        </v-flex>
        <!-- Submit / Sync Grades -->
        <v-flex
          xs12
          id="submit-sync-grades"
          v-if="(
            user.isLti
            && !isPlaylist
            && user.userType === 'student'
            && !bulb.config.hide_learner_score
            && user.gradePassbackUrl
            && user.enableGrading === 1
          )"
        >
          <!-- Button to manually / force a grade sync: -->
          <v-btn
            block
            color="primary"
            v-if="(
              bulbAttempt.complete
              && ltiSynced !== 'pending'
              && !isPlaylist
            )"
            @click="syncLtiGrade"
            :loading="ltiExporting"
            :disabled="(
              ltiSynced
              || scoreThreshold.scoreThresholdEnabled
            )"
            :outline="ltiSynced"
            aria-label="ltiSynced ? 'Sync Grades' : 'Grades Submitted'"
          >
            {{ltiSynced ? 'Submitted' : 'Sync Grades'}}
          </v-btn>
          <!-- Button to manually / force to retrieve status of grade sync: -->
          <v-btn
            v-if="(
              ltiSynced === 'pending'
              && !isPlaylist
            )"
            block
            color="primary"
            outline
            @click="syncLtiGradeStatus"
            :disabled="scoreThreshold.scoreThresholdEnabled"
            aria-label="Check Grade Syncing Status"
          >
            Sync Status
          </v-btn>
        </v-flex>
        <!-- View Report(s): -->
        <v-flex xs12 >
          <v-btn
            v-if="canDownloadHtml"
            @click="downloadHtml"
            :loading="isDownloadingHtml"
            :disabled="isDownloadingHtml"
            block
            color="primary"
            outline
            aria-label="Download grades in an HTML file."
          >
            Download My Results (HTML)
          </v-btn>
          <v-btn
            @click="downloadDocx"
            v-if="(
              canDownloadDocx
              && !isDocxButtonInProminentPosition
            )"
            :loading="isDownloadingDocx"
            :disabled="isDownloadingDocx"
            block
            color="primary"
            outline
            aria-label="Download grades in a DOCX file."
          >
            Download My Results (DOCX)
          </v-btn>
          <v-btn
            @click="downloadPdf"
            v-if="canDownloadPdf"
            :loading="isDownloadingPdf"
            :disabled="isDownloadingPdf"
            block
            color="primary"
            outline
            aria-label="Download grades in a PDF file."
          >
            Download My Results (PDF)
          </v-btn>
          <v-btn
            v-if="canViewPdf"
            @click="viewPdf"
            block
            color="primary"
            outline
            aria-label='view grades pdf'
          >
            View My Results
          </v-btn>
        </v-flex>
        <v-flex xs12 v-if="(
          showFinishExit
          && isDocxButtonInProminentPosition
        )">
          <v-btn
            @click="isProquestBulb ? handleProquestFinishExitClick() : finishExitClicked()"
            v-if="!isPlaylist && !isListcode"
            id="finish-and-exit"
            block
            aria-label='Finish and exit'
            color="primary"
            outline
          >
            Finish and Exit
          </v-btn>
        </v-flex>
        <v-flex xs12>
          <div v-if='(
            bulbAttempt.complete
            && !score.ungraded
            && !bulb.config.hide_learner_score
            && !isPlaylist
            && !isListcode
            && isLmb
            && hasRubric
          )'
        >
            <h2
              class="bulb-info-subheader text-xs-center mt-2 finishedText"
            >
              <span>
                Review is complete. The learner rubric score you provided{{lmbCreatorMessage}} is {{score.percent}}%.
              </span>
            </h2>
            <h2
              class="bulb-info-subheader text-xs-center mt-2 finishedText"
            >
              <span>
                Close this tab and return to your class.
              </span>
            </h2>
          </div>
          <h2
            v-else-if="(
              bulbAttempt.complete
              && !score.ungraded
              && !bulb.config.hide_learner_score
              && !isPlaylist
              && !isListcode
              && !isProquestBulb
            )"
            class="bulb-info-subheader text-xs-center mt-2 finishedText"
          >
              <span v-if="!isBarbri">All done. You can return to your class.</span>
              <span v-else>You may close the player and return to your PSP.</span>
          </h2>
        </v-flex>
      </v-layout>
      <v-layout wrap class="bulb-info-buttons">
        <!-- Retry Bulb -->
        <v-flex xs12  v-if="shouldShowRetakeButton">
          <v-dialog
            v-model="dialog"
            width="500"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                color="primary"
                outline
                block
                v-on="on"
              >
                Retake
              </v-btn>
            </template>
            <v-card>
              <v-card-title
                class="orange lighten-1 font-weight-medium"
              >
                <v-icon class="mr-1">priority_high</v-icon>
                <span>WARNING: RETAKING DELETES ALL DATA</span>
              </v-card-title>
              <v-card-text>
                This will clear all previous answer selections and erase notes. <a @click="downloadNotes">Download notes</a> prior to continuing. Your next attempt will overwrite your score in the gradebook.
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-btn
                  @click="dialog = false"
                  :disabled="retryWaiting"
                  aria-label='Cancel retake'
                  color="#858585"
                  flat
                >
                  Cancel
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  @click="retryBulb()"
                  :loading="retryWaiting || downloadingNotes"
                  :disabled="!bulbAttempt.complete && !scoreThreshold.scoreThresholdEnabled || downloadingNotes"
                  aria-label="Retake"
                >
                  Retake
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-flex>
        <!-- Copy Bulb -->
        <v-flex
          xs8
          offset-xs2
          sm6
          offset-sm3
          v-if="(
            user.userType !== 'student'
            && !isPeerReview
            && !isPlaylist
            && !isProquestBulb
          )"
        >
          <v-btn
            block
            color="primary"
            outline
            @click="setShowCopyBulbModal(true)"
            :loading="copyingBulb"
            :aria-label='`Copy ${termForBulb.capitalize()}`'
          >
              Copy {{termForBulb.capitalize()}}
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout
        v-if="(
          !isBroadcast
          && !hasRubric
          && (
            bulb.bulbVideos.length > 1
            || interactionStates.length > 0
          )
        )"
        wrap>
        <chapter-markers></chapter-markers>
      </v-layout>
     </v-content>
  </div>
</template>

<script>

// [ ] we should probably refactor this to have Review.vue that contains BulbInfo.vue and ChapterMarkers.vue
// structure would look like
// Review.vue
//   BulbInfo.vue
//   ChapterMarkers.vue

/* eslint-disable */

// Custom components:
import ChapterMarkers from './ChapterMarkers';

// Services:
import PlayerService from '@/services/PlayerService';
import XApiService from '@/services/XApiService';

// Plugins / Libraries:
import _ from 'lodash';
const FileSaver = require('file-saver');
window.lodash = _;
import {
  mapState,
  mapActions,
  mapGetters,
  mapMutations
} from 'vuex';

export default {
  name: 'bulb-info',
  components: {
    ChapterMarkers,
  },
  data() {
    return {
      dialog: false,
      downloadingNotes: false,
      notes: [],
      retryFailed: false,
      retryWaiting: false,
      lmbCreatorMessage: '',
      isDownloadingPdf: false,
      isDownloadingHtml: false,
      isDownloadingDocx: false,
      teacherToken: '',
    };
  },
  computed: {
    ...mapState('player', [
      'bulbIsPD',
      'formatedDuration',
      'hasPlaylistScoreThreshold',
      'sessionId',
      'isListcode',
      'isLiveSession',
      'lti13Launch',
    ]),
    ...mapGetters('player', [
      'bulb',
      'bulbAttempt',
      'bulbFinished',
      'copyingBulb',
      'hasRubric',
      'isBroadcast',
      'isLmb',
      'isPeerReview',
      'isPlaylist',
      'lmsLaunch',
      'ltiExporting',
      'ltiExportFailed',
      'ltiSynced',
      'mobile',
      'mobileIOS',
      'playerApiPrefix',
      'queryParams',
      'schoolId',
      'user',
      'isProquestBulb',
      'termForBulb',
    ]),
    ...mapGetters('interactions', [
      'interactions',
      'interactionStates',
    ]),
    // from vuex
    shouldShowRetakeButton() {
      return (
        this.user.userType === 'student'
        && this.bulb.config.retry_yes
        && (
          this.bulbAttempt.complete
          || this.scoreThreshold.scoreThresholdEnabled
        )
      );
    },

    /*
      `canDownloadPdf`, `canDownloadHtml`, `canDownloadDocx`, and `canViewReportInNewTab` all
      follow a similar flow in order to support the older method of enabling these buttons as well as the new method that's done via Bulb Settings. They must either have the new option enabled OR have no traces of the new options and also meet the previous criteria.
    */
    canDownloadPdf() {
      return (
        !_.find(this.bulb.banks, {'type': 'random'})
        && this.bulbAttempt.complete
        && !_.get(this.bulb, 'lmbId', 0)
        && this.user.userType === 'student'
        && (
          (
            this.bulb.config.export_yes
            && this.bulb.config.enablePdfReport
          ) || (
            !_.has(this.bulb.config, 'enableViewReport')
            && !_.has(this.bulb.config, 'enablePdfReport')
            && !_.has(this.bulb.config, 'enableHtmlReport')
            && !_.has(this.bulb.config, 'enableDocxReport')
            &&  _.get(this, 'bulb.teachers[0].school.permissionKeys', []).includes('showDownloadPdfBulbResultsButton')
          )
        )
      );
    },
    canDownloadHtml() {
      return (
        !_.find(this.bulb.banks, {'type': 'random'})
        && this.bulbAttempt.complete
        && !_.get(this.bulb, 'lmbId', 0)
        && this.user.userType === 'student'
        && (
          (
            this.bulb.config.export_yes
            && this.bulb.config.enableHtmlReport
          ) || (
            !_.has(this.bulb.config, 'enableViewReport')
            && !_.has(this.bulb.config, 'enablePdfReport')
            && !_.has(this.bulb.config, 'enableHtmlReport')
            && !_.has(this.bulb.config, 'enableDocxReport')
            &&  _.get(this, 'bulb.teachers[0].school.permissionKeys', []).includes('showDownloadHtmlBulbResultsButton')
          )
        )
      );
    },
    canDownloadDocx() {
      return (
        !_.find(this.bulb.banks, {'type': 'random'})
        && this.bulbAttempt.complete
        && !_.get(this.bulb, 'lmbId', 0)
        && this.user.userType === 'student'
        && (
          (
            this.bulb.config.export_yes
            && this.bulb.config.enableDocxReport
          ) || (
            !_.has(this.bulb.config, 'enableViewReport')
            && !_.has(this.bulb.config, 'enablePdfReport')
            && !_.has(this.bulb.config, 'enableHtmlReport')
            && !_.has(this.bulb.config, 'enableDocxReport')
            &&  _.get(this, 'bulb.teachers[0].school.permissionKeys', []).includes('showDownloadDocxBulbResultsButton')
          )
        )
      );
    },
    isDocxButtonInProminentPosition() {
      return _.get(this, 'bulb.teachers[0].school.permissionKeys', []).includes('prominentDownloadDocxBulbResultsButton');
    },
    canViewReportInNewTab() {
      return (
        this.bulb.config.export_yes
        && (
          this.bulb.config.enableViewReport
          || (
            !_.has(this.bulb.config, 'enableViewReport')
            && !_.has(this.bulb.config, 'enablePdfReport')
            && !_.has(this.bulb.config, 'enableHtmlReport')
            && !_.has(this.bulb.config, 'enableDocxReport')
          )
        )
      );
      return _.get(this, 'bulb.teachers[0].school.permissionKeys', []).includes('showDownloadDocxBulbResultsButton');
    },
    canViewPdf() {
      // Hide PDF button if bulb contains random question banks
      if (_.find(this.bulb.banks, {'type': 'random'})) return false;
      // BulbAttempt must be complete
      if (this.bulbAttempt.complete) {
        // Don't show button if bulb is LMB or if user is not a student
        if (_.get(this.bulb, 'lmbId', 0) || this.user.userType !== 'student') return false;
        // If export_yes flag turned off
        if (!this.canViewReportInNewTab) return false;
        return true;
      }
      return false;
    },
    isBarbri() {
      // As of now, BARBRI only requires us to change this text for 3 of their 5 subaccounts.
      // The main BARBRI one, Bar Prep, and SQE.
      return [883, 2233, 2234].includes(this.schoolId);
    },
    finishUrl() {
      if (this.bulbIsPD) {
        return `/dash/?token=${ this.teacherToken }&view=PD`;
      } else if (_.has(this.user, 'token')) return `/dash/?token=${ this.user.token }`;
      else return '/dash/'
    },
    progressCircle() {
      if (this.bulbAttempt.complete) {
        return this.bulb.config.hide_learner_score ? 100 :  this.score.percent;
      }
      return 25;
    },
    score() {
      /**
       * returns the scores for a given student_lesson attempt
       */
      let ungraded = this.calcUngradedFreeResponse();
      const percent = (() => {
        if (this.user.userType === 'student') {
          if (this.bulbAttempt.pointsAvailable === 0) return 100;
          return Math.round(100 * (this.bulbAttempt.pointsEarned / this.bulbAttempt.pointsAvailable)) // Score of the lesson in percent
        }
        return this.bulbAttempt.complete ? 100 : 0;
      })()
      return {
        percent, // percent correct out of 100
        ungraded, // ungraded free response
      }
    },
    scoreThreshold() {
        const bulbPointsAvail = this.bulbAttempt.pointsAvailable;
        const bulbPointsEarned = this.bulbAttempt.pointsEarned;
        const bulbScoreThreshold = this.bulb.config?.scoreThreshold;
        return {
          scoreThresholdEnabled: (
            !this.isLiveSession &&
            !this.isBroadcast &&
            this.bulbFinished &&
            this.user.userType !== 'teacher' && 
            this.bulb.config?.scoreThreshold &&
            this.bulb.config.retry_yes &&
            Math.round((bulbPointsEarned / bulbPointsAvail) * 100) < bulbScoreThreshold
          ),
          bulbScoreThreshold,
        };
    },
    showFinishExit() {
      if (this.bulbAttempt.complete) {
        if (!this.user.id) return false; // anon never has finish/exit
        if (this.user.userType === 'teacher') return !this.user.hasStudentIdentity && !this.lmsLaunch; // teacher cannot be launching from lms or be a student account
        else return !this.isPeerReview && !this.user.isLti && !this.isPlaylist; // student can't be lti or peer reviewing
      }
      return false;
    },
    getUserName() {
      if(
        (
          this.user.firstName === 'firstName'
          && this.user.lastName === 'lastName'
        ) || (
          this.user.firstName === 'User'
          && this.user.lastName === 'Anonymous'
        )
      ) {
        return 'anonymous';
      }
      return `${this.user.firstName} ${this.user.lastName}`;
    },
  },
  methods: {
    ...mapMutations('player', [
      'setShowCopyBulbModal',
      'setSnackbar',
    ]),
    ...mapActions('player', [
      'syncLtiGrade',
      'syncLtiGradeStatus',
    ]),
    calcUngradedFreeResponse() {
      let ungraded = 0
      // loop interactions that are free response
      this.interactionStates.forEach((is) => {
        if (!is.interaction.autograde && _.has(is,'interactionAttempt.pointsEarned') && is.interactionAttempt.pointsEarned === null) {
          ungraded++;
        }
      })
      return ungraded;
    },
    async downloadNotes() {
      try {
        this.downloadingNotes = true;
        const  response = await PlayerService.getAttemptNotes(this.bulbAttempt.id);
        this.notes = response.data;
        let html = '';
        this.notes.forEach((c, i) => {
          c.text = c.text.replace(/\<(?!img|audio).*?\>/g, "");
          html += `(${this.formatedDuration(c.displayTime)}) - ` + c.text + '\r\n\r\n';
        });
        const blob = new Blob([html], {type: 'text/plain;charset=utf-8'});
        FileSaver.saveAs(blob, 'playposit-notes.txt');
      } catch(e) {
        this.setSnackbar({
          color: 'error',
          text: 'Error downloading notes.'
        });
      } finally {
        this.downloadingNotes = false;
      }
    },
    async handleProquestFinishExitClick() {
      const { data: bulbAttempt } = await PlayerService.sendProquestBulbAttemptUpdate({
        bulbAttemptId: this.bulbAttempt.id,
        event: 'exit',
      });
      if (
        bulbAttempt?.id
        && window.self !== window.top
      ) {
        window.parent.postMessage(JSON.stringify({
          type: 'bulbAttempt',
          event: 'exit',
          data: _.omit(bulbAttempt, ['bulb']),
        }), '*');
      }
    },
    async handlePlaylistBulbRetry() {
      if (
        this.bulbAttempt?.id
        && window.self !== window.top
      ) {
        window.parent.postMessage(JSON.stringify({
          type: 'playposit__playlist_bulbRetry',
          event: 'retry',
          data: this.bulbAttempt.bulbId,
        }), '*');
      }
    },
    finishExitClicked() {
      try {
        const parent = window.parent != null ? window.parent : (window.top != null ? window.top : null);
        if (parent != null) {
          let postObject = {
            'type': 'playposit__event',
            'button': 'finish-and-exit',
            'action': 'click',
          }
          parent.postMessage(JSON.stringify(postObject), '*');
        }
      } catch (e) {
      } finally {
        window.location.href = this.finishUrl;
      }
    },
    retryBulb() {
      /**
       * Soft delete existing student_lesson and associated student_answers then refresh bulb so student can retry_yes the bulb.
       */
      if (this.retryFailed) {
        // prevent multiple calls to retry if it failed once before.
        this.setSnackbar({
          color: 'error',
          text: 'This attempt was already archived. Please refresh the page.',
        });
        return;
      }
      this.retryWaiting = true;
      PlayerService.retryBulbAttempt(this.bulbAttempt.id)
      .then((res) => {
        if (_.has(res.data,'redirect')) {
          // if the response was a broadcast, or redirect to another student_lesson id we redirect here
          if (this.isPlaylist) res.data.redirect += '&playlist=true';
          if (this.hasPlaylistScoreThreshold) res.data.redirect += `&scoreThreshold=${this.bulb.config.scoreThreshold}`;
          if (this.lti13Launch) res.data.redirect += '&lti13Launch=true';
          if (this.queryParams.get('issuer')) res.data.redirect += `&issuer=${this.queryParams.get('issuer')}`;
          if (this.isPlaylist) this.handlePlaylistBulbRetry();
          location.href = res.data.redirect;
        } else {
          // otherwise just reload the current page, getInitialBulbData() will grab the most recent bulbAttempt
          location.reload();
        }
      })
      .catch((err) => {
        this.retryWaiting = false; // turn off spinner
        if (err.label === 'read_only_unauthorized') return;
        else if (err.response.data.error === 'no_bulb_attempt') {
          this.setSnackbar({ color: 'error', text: 'This attempt was already archived. Please refresh the page.' });
        }
        else if (err.response.data.error === 'bulb_attempt_limit_reached') {
          this.setSnackbar({
            bluescreen: {
              title: `Cannot Reattempt ${this.termForBulb.capitalize()}`,
              subtitle: "",
              text: 'Your instructor has exceeded the number of learner attempts that can be made per month on a free account. You will not be able to proceed unless your instructor upgrades to a Pro account, or until next month.',
            },
            color: 'error',
            text: `Attempt Limit Reached.`,
            timeout: 0,
          });
        }
        else if (err.response.data.name === 'BulbAttemptRetakeLimitError') {
          // this.setSnackbar({ color: 'error', text: err.response.data.msg });
          this.setSnackbar({
            bluescreen: {
              title: `Cannot Reattempt ${this.termForBulb.capitalize()}`,
              subtitle: "",
              text: err.response.data.msg,
            },
            color: 'error',
            text: 'Retake Limit Reached.',
            timeout: 0,
          });
        }
        else {
          this.setSnackbar({ color: 'error', text: 'Sorry there was an error while resetting this lesson.' });
        }
        this.retryFailed = true; // prevent ajax calls to errored bulbAttempt retry
        if (err.enableLogging) {
          dataLayer.errorLog(err, {
            sessionId: this.sessionId,
            message_data_keys: ['data.error'],
            status_data_keys: ['status']
          });
        }
      })
      XApiService.buildResetLessonStatement({
        activity: {
          id: `https://xapi.playposit.com/activities/video/${this.bulb.id}`,
          name: this.bulb.name,
          lesson_id: this.bulb.id
        }
      });
    },
    async viewPdf() {
      if (!_.has(this.user,'id')) {
        EventBus.$emit('triggerSnackbar', { color: 'warning', text: 'Please login to export PDF.' });
      } else {
        const url = `${this.playerApiPrefix}print?type=bulb_attempt&bulb_id=${this.bulb.id}&section_id=${this.bulbAttempt.sectionId}&student_id=${this.user.id}`;
        window.open(url,'_blank','height=800,width=800,left=10,top=10,scrollbars=yes,menubar=no');
        PlayerService.createBulbAttemptView({
          bulbAttemptId: this.bulbAttempt.id,
        });
      }
    },
    async downloadPdf() {
      this.isDownloadingPdf = true;
      const microserviceUrl = `${window.location.origin}/print?type=bulb_attempt&bulb_id=${this.bulb.id}&section_id=${this.bulbAttempt.sectionId}&student_id=${this.user.id}`;
      if (_.get(this, 'bulb.teachers[0].school.permissionKeys', []).includes('usePuppeteerForDownloadingBulbResultsPdfs')) {
        let data;
        try {
          const response = await PlayerService.convertUrlToPdf(microserviceUrl);
          data = response.data;
        } catch(e) {
          this.isDownloadingPdf = false;
          return this.setSnackbar({
            color: 'error',
            text: e.message,
          });
        }
        const blob = new Blob([data], {type: 'application/pdf'})
        const blobUrl = URL.createObjectURL(blob);

        const link = document.createElement('a');
        const date = new Date();

        link.href = blobUrl;
        link.download = `PlayPositBulbResults_${date.getMonth() + 1}-${date.getDate()}-${date.getFullYear()}.pdf`;

        document.body.appendChild(link);

        link.dispatchEvent(
          new MouseEvent('click', { 
            bubbles: true, 
            cancelable: true, 
            view: window 
          }),
        );

        document.body.removeChild(link);
        this.isDownloadingPdf = false;
        return;
      }
      const element = document.createElement('iframe');
      element.src = `${microserviceUrl}&autogenerate=pdf`;
      element.style.border = '0';
      element.style.width = '800px';
      element.style.height = '100vh';
      element.style.position = 'fixed';
      element.style.bottom = '0';
      element.style.left = '0';
      element.style.zIndex = '-9999999';
      document.body.appendChild(element);
      window.addEventListener('message', (event) => {
        if (event.data === 'pdfGenerationSuccess') {
          document.body.removeChild(element);
          PlayerService.createBulbAttemptView({
            bulbAttemptId: this.bulbAttempt.id,
          });
          this.setSnackbar({
            color: 'success',
            text: 'A PDF file containing your results has been successfully downloaded.',
          });
          this.isDownloadingPdf = false;
        } else if (event.data === 'pdfGenerationError') {
          document.body.removeChild(element);
          this.setSnackbar({
            color: 'error',
            text: 'An error occurred while downloading your results.',
          });
          this.isDownloadingPdf = false;
        }
      });
    },
    downloadHtml() {
      this.isDownloadingHtml = true;
      const element = document.createElement('iframe');
      element.src = `${this.playerApiPrefix}print?type=bulb_attempt&bulb_id=${this.bulb.id}&section_id=${this.bulbAttempt.sectionId}&student_id=${this.user.id}&autogenerate=html`;
      element.style.border = '0';
      element.style.width = '800px';
      element.style.height = '100vh';
      element.style.position = 'fixed';
      element.style.bottom = '0';
      element.style.left = '0';
      element.style.zIndex = '-9999999';
      document.body.appendChild(element);
      window.addEventListener('message', (event) => {
        if (event.data === 'htmlGenerationSuccess') {
          document.body.removeChild(element);
          PlayerService.createBulbAttemptView({
            bulbAttemptId: this.bulbAttempt.id,
          });
          this.setSnackbar({
            color: 'success',
            text: 'An HTML file containing your results has been successfully downloaded.',
          });
          this.isDownloadingHtml = false;
        } else if (event.data === 'htmlGenerationError') {
          document.body.removeChild(element);
          this.setSnackbar({
            color: 'error',
            text: 'An error occurred while downloading your results.',
          });
          this.isDownloadingHtml = false;
        }
      });
    },
    async downloadDocx() {
      try {
        this.isDownloadingDocx = true;
        const { data: blob } = await PlayerService.downloadBulbResultsInDocxFormat({
          bulbId: this.bulb.id,
          studentId: this.user.id,
          sectionId: this.bulbAttempt.sectionId,
        });
        const date = new Date();
        const link = document.createElement('a');
        link.style.position = 'absolute';
        link.style.top = '-1000px';
        link.style.left = '-1000px';
        link.href = window.URL.createObjectURL(blob);
        link.download = `PlayPosit${this.termForBulb.capitalize()}Results_${date.getMonth() + 1}-${date.getDate()}-${date.getFullYear()}.docx`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        this.setSnackbar({
          color: 'success',
          text: 'A DOCX file containing your results has been successfully downloaded.',
        });
        PlayerService.createBulbAttemptView({
          bulbAttemptId: this.bulbAttempt.id,
        });
      } catch(e) {
        this.setSnackbar({
          color: 'error',
          text: 'An error occurred while downloading your results.',
        });
      } finally {
        this.isDownloadingDocx = false;
      }
    },
  },
  async mounted() {
    if (this.isLmb && this.hasRubric) {
      const bulbCreator = this.bulb.teachers.find(teacher => teacher.isAdmin === 3);
      if (bulbCreator) {
        this.lmbCreatorMessage = ` for ${bulbCreator.firstName}`;
      }
    }
    if (this.bulbIsPD) {
      const { data: teacherToken } = await PlayerService.getTeacherToken();
      this.teacherToken = teacherToken;
    }
  },
};

</script>

<style>

#bulb-info {
  display:flex;
  flex-direction: column;
  min-height: 0;
  flex-grow: 1;
}

#bulb-info .v-btn {
    max-width: 250px;
    margin-left: auto;
    margin-right: auto;
}

#bulb-info .content--wrap {
  flex: 1 !important;
}


/* there are no longer v-lists in bulb info, we should remove these*/
#bulb-info .v-list__tile {
  height: auto !important;
}

#bulb-info .v-list__tile__sub-title {
  display: block !important;
}

#bulb-info .v-list__tile .v-list__tile__title,
#bulb-info .v-list__tile .v-list__tile__sub-title {
  white-space: normal;
  overflow: visible;
  height: auto;
}

#bulb-info .v-list__tile .v-list__tile__content {
  /*overflow: visible;*/
  max-width: 100%;
}

.bulb-info-title {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

</style>